import { ToggleComponent } from '../../../featureToggle';
import RegisterForm from './RegisterForm';
import FreshwatchRegisterForm from '../../../customized/fresh-watch/components/auth/RegisterForm/FreshwatchRegisterForm';

export default ToggleComponent(RegisterForm, {
  styledComponentsVariants: {
    'fresh-watch': FreshwatchRegisterForm,
  },
});
